import React from 'react';
import { useDoubleTap } from 'use-double-tap';

import { Props } from './types';

const Component: React.FC<Props> = ({ children, onDoubleTap, onSingleTap }) => {
  const handleDoubleTap = React.useCallback(() => onDoubleTap?.(), [
    onDoubleTap,
  ]);
  const bind = useDoubleTap(handleDoubleTap, 300, { onSingleTap });
  return <div {...bind}>{children}</div>;
};

Component.displayName = 'Tapper';

export default React.memo(Component);
